import { JobSearch } from '@types'

import SearchForm from './search'

import styles from './index.module.scss'

import type { JSX } from 'react'

export default function JobsSidebar({ search }: { search: JobSearch }): JSX.Element {
  return (
    <div className={styles.sidebar}>
      <SearchForm search={search} />
    </div>
  )
}
